define('responsive-game-feed/app/scripts/utils/Tracking',['require','exports','module','tracking/omniture'],function(require, exports, module) {
 
 var trackingLib = require("tracking/omniture");
 
 var Tracking = {
		track : function( params ) {
			
			var om = new trackingLib.OmnitureAsync(params);
				om.prop11 = "Dynamic Page View";
            var props = om.assign();
            props.prop22 = null;
            props.prop15 = null;
            props.prop13 = "Major League Baseball: Gameday: Gameday"
            om.fire();
		}
	}
	
	return Tracking

});
